<template>
  <!-- 对话框 -->
  <el-dialog :title="submit_data.name" :visible.sync="show" width="60%" top="2vh" :before-close="closeDialog"
    :close-on-click-modal="false">
    <div style="height: 72vh ;overflow-y: auto;">


      <!-- 基本信息表单 -->
      <div class="form-box">
        <el-form ref="form" :model="submit_data" label-width="80px">



          <el-form-item label="小组名" label-width="125px">
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" :maxlength=11>
            </el-input>
          </el-form-item>

          <el-form-item label="管理状态:" label-width='120px'>

            <!-- <el-select v-model="submit_data.status" placeholder="请选择状态" style="width: 150px; margin-right: 20px;"
              clearable>
              <el-option v-for="item in status_select" :label="item.alias" :value="item.val" @change="statusChange">
              </el-option>
            </el-select> -->
            <el-radio v-model="radio" label="0">未开启</el-radio>
            <el-radio v-model="radio" label="1">已开启</el-radio>
            <!-- <el-radio v-model="submit_data.status" :label="String(item.val)" v-for="(item, index) in status_select"
              :key="item.val">{{ item.alias }}</el-radio> -->
          </el-form-item>

          <el-form-item label="备注" label-width="125px">
            <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
  var _this

  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'editcode': ''
    },
    watch: {

      isShow(newData, oldData) {
        _this.show = true;

        console.log(this.editcode);

        this.$post(
            "/city/getCityGroupDetails", {
              'city_group_code': this.editcode
            }
          )
          .then(res => {

            console.log(res.data);
            this.status_select = res.data.status.select_array;

            this.submit_data.city_group_code = res.data.city_group.city_group_code
            this.submit_data.name = res.data.name
            this.submit_data.remarks = res.data.remarks
            this.radio = res.data.status.val;


          })

      },
      data(newData, oldData) {

        this.options_city_code = newData;

      },





    },
    data() {
      return {
        options_city_code: [],
        radio: '',
        submit_data: {
          city_group_code: '',
          status: '',
          name: '',
          remarks: ''
        },

        status_select: [],
        show: false,





        submit_rules: {

          name: {
            placeholder: '城市名称',
            rules: {
              required: true,
              message: '城市名称过长，请保持在30汉字之内',
              regulation: 'elt_str',
              rulesData: 30
            }
          },
          remarks: {
            placeholder: '填写备注',
            rules: {
              required: false,
              message: '填写备注',
              regulation: 'elt_str',
              rulesData: 30
            }
          },

        }


      };
    },
    created() {
      _this = this;
    },

    methods: {


      closeDialog() {

        _this.show = false;


      },
      // 提交
      onSubmit() {

        _this.submit_data.status = this.radio



        _this.$post(
            "/city/editCityGroupSubmit",
            _this.submit_data,

            _this.submit_rules
          )
          .then(res => {
            console.log(res)
            this.$message.success(res.msg);
            _this.$emit('onSubmit')

            setTimeout(() => {

              _this.closeDialog();

            }, 1000);


          })
      },



    }
  };
</script>

<style scoped>
  #container_edit {
    height: 90%;
    width: 35%;
    float: left;
  }

  .form-box {
    width: 65%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
</style>